import React, { useState, useEffect } from "react";
import s from "./StockInstantaneos.module.css";

//utilities
import { Currency } from "../../../helpers/currencyConvert";
import Pager from "../../Shared/Pagination/Pagination";
import exportToExcel from "../../../helpers/exportExcel";
import couponsService from "../../../api/delivery/couponsService";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import gamesService from "../../../api/games/GamesService";

import {
  Alert,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalPrintshopRoundedIcon from "@mui/icons-material/LocalPrintshopRounded";
import DescriptionIcon from "@mui/icons-material/Description";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

export const StockInstantaneos = () => {
  const servicesCoupons = couponsService();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { textColor } = useSelector((state) => state.local);
  const { activeOrganization } = useSelector((state) => state.gamma);

  const [filters, setFilters] = useState({
    gameId: 0,
    raffleId: 0,
  });
  const [openError, setOpenError] = useState(false);
  const [noResult, setNoResult] = useState(false);

  const [loadingGames, setLoadingGames] = useState(false);
  const [games, setGames] = useState([]);
  const [raffles, setRaffles] = useState([]);

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  //Paginado
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCustom, setPageCustom] = useState(1);

  const handleExport = () => {
    // setLoadingExcel(true);
    // getAllMovements(filters.gameId, filters.raffleId)
    //   .then(res => {
    let today = new Date();
    let game = items[0].game.name;
    let toExport = items.map((item) => ({
      Modalidad: item?.raffle?.serie || "-",
      Remito: item?.deliveryNoteOutputId || item?.deliveryNoteInputId || "-",
      Valor: item?.raffle?.price || "-",
      Comision: `${item?.raffle?.percentage || 0} %`,
      Cupon_Desde: item?.nroCouponFrom || "-",
      Cupon_Hasta: item?.nroCouponTo || "-",
      Cantidad: item?.nroCouponTo - item?.nroCouponFrom + 1 || "-",
      Movimiento: item?.deliveryNoteInputId ? t("income") : t("discharge"),
    }));
    exportToExcel(
      toExport,
      `${t("queryStock")} ${t("instant")} - ${game} ${today.toISOString()}`,
    );
    // })
    // .then(() => setLoadingExcel(false))
  };

  const getStock = () => {
    setLoading(true);
    servicesCoupons
      .getMovements(page, pageSize, filters.gameId, filters.raffleId)
      .then((res) => {
        if (res?.content?.length === 0) {
          setNoResult(true);
        }
        setItems(res.content);
        setTotalPages(res.totalPages);
        setLoading(false);
      })
      .catch(() => {
        setOpenError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoadingGames(true);
    gamesService
      .getAllGames()
      .then((res) => {
        setGames(res.content);
      })
      .then(() => setLoadingGames(false));
  }, []);

  useEffect(() => {
    setFilters((prev) => ({ ...prev, raffleId: 0 }));
    if (filters.gameId) {
      servicesCoupons
        .getItemsByGameSerie(1, 100, dispatch, filters?.gameId)
        .then((res) => {
          setRaffles(res);
        });
    }
  }, [filters.gameId]);

  useEffect(() => {
    if (filters.gameId) {
      getStock();
    }
  }, [page, pageSize, filters.gameId]);

  return (
    <Grid container className={s.container}>
      <Grid item xs={12} className={s.header}>
        <Grid item container xs={12} className={s.titleContainer}>
          <Grid
            item
            xs={11}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Inventory2Icon
              sx={{ fontSize: "2rem", color: "primary.main", mr: 2 }}
            />
            <h4>{t("instantStock")}</h4>
          </Grid>
        </Grid>
      </Grid>

      <Grid item container xs={11} className={s.filters}>
        <Grid item xs={11.4}>
          <h4
            style={{
              fontSize: "1.5rem",
              fontWeight: 300,
              marginTop: 0,
            }}
          >
            {t("filter")}
          </h4>
        </Grid>
        {loadingGames ? (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              mb: 4,
            }}
            className={s.loaderGames}
          >
            <CircularProgress sx={{ mr: 3 }} />
            {t("loadingFilter")}
          </Grid>
        ) : (
          <>
            <Grid item container xs={11} md={5} lg={3} className={s.item}>
              <FormControl sx={{ width: "95%" }} className={s.init1}>
                <InputLabel>{t("game")}</InputLabel>
                <Select
                  value={filters.gameId}
                  label={t("game")}
                  sx={{ width: "100%" }}
                  onChange={(e) =>
                    setFilters((prev) => ({ ...prev, gameId: e.target.value }))
                  }
                >
                  <MenuItem value={0}>{t("select")}</MenuItem>
                  {games?.map((item, i) => {
                    if (item?.modality?.mode?.id === 2) {
                      return (
                        <MenuItem key={i} value={item.modality?.game?.id}>
                          {item?.modality?.game?.name}
                        </MenuItem>
                      );
                    }
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
              <FormControl sx={{ width: "95%" }} className={s.init1}>
                <InputLabel>{t("modality")}</InputLabel>
                <Select
                  value={filters.raffleId}
                  label={t("modality")}
                  sx={{ width: "100%" }}
                  disabled={!filters.gameId}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      raffleId: e.target.value,
                    }))
                  }
                >
                  <MenuItem value={0}>{t("select")}</MenuItem>
                  {raffles?.map((item, i) => {
                    return (
                      <MenuItem key={i} value={item.raffle?.id}>
                        {item?.raffle?.serie}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              container
              xs={11}
              md={5}
              lg={1}
              className={[s.item, s.init3]}
            >
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  disabled={!filters.gameId}
                  onClick={getStock}
                >
                  {t("consult")}
                </Button>
              </Grid>
            </Grid>
            <Grid item container xs={12} className={[s.item, s.init2]}>
              <Grid item xs={2}>
                {raffles.length ? (
                  <h4
                    style={{
                      marginBottom: 0,
                    }}
                  >
                    Stock:{" "}
                    {loading ? (
                      <CircularProgress size={"1rem"} />
                    ) : filters?.raffleId ? (
                      raffles
                        .find((r) => r.raffle.id === filters?.raffleId)
                        ?.totalitems?.toLocaleString()
                    ) : (
                      raffles
                        .reduce((acc, b) => acc + b.totalitems, 0)
                        ?.toLocaleString()
                    )}
                  </h4>
                ) : null}
              </Grid>
              <Grid item xs={10} className={s.options}>
                <Button
                  onClick={() => window.print()}
                  variant="contained"
                  disabled={!items?.length}
                >
                  <LocalPrintshopRoundedIcon
                    color={textColor}
                    sx={{ fontSize: "1.5rem" }}
                  />
                  <p>{t("print")}</p>
                </Button>
                <Button
                  onClick={() => handleExport()}
                  variant="contained"
                  disabled={!items?.length}
                  sx={{ ml: 1 }}
                >
                  {/*{*/}
                  {/*  loadingExcel ? <CircularProgress/> :*/}
                  {/*    <>*/}
                  <DescriptionIcon
                    color={textColor}
                    sx={{ fontSize: "1.5rem" }}
                  />
                  <p>Excel</p>
                  {/*    </>*/}
                  {/*}*/}
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>

      {loading ? (
        <Grid item xs={12} className={s.loader}>
          <CircularProgress size={"4rem"} />
        </Grid>
      ) : (
        <Grid item container xs={11} className={s.data}>
          {items?.length ? (
            <Grid item xs={12}>
              <TableContainer className={s.tableContainer}>
                <Table>
                  <TableHead sx={{ backgroundColor: "primary.main" }}>
                    <TableCell
                      sx={{ color: textColor }}
                      className={s.tableTitle}
                    >
                      {t("modality")}
                    </TableCell>
                    <TableCell
                      sx={{ color: textColor }}
                      className={s.tableTitle}
                    >
                      {t("deliveryNoteNumber")}
                    </TableCell>
                    <TableCell
                      sx={{ color: textColor }}
                      className={s.tableTitle}
                    >
                      {t("couponValue")}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: textColor }}
                      className={s.tableTitle}
                    >{`${t("commissions")} (%)`}</TableCell>
                    <TableCell
                      sx={{ color: textColor }}
                      className={s.tableTitle}
                    >{`${t("coupons")} ${t("from")}`}</TableCell>
                    <TableCell
                      sx={{ color: textColor }}
                      className={s.tableTitle}
                    >{`${t("coupons")} ${t("to")}`}</TableCell>
                    <TableCell
                      sx={{ color: textColor }}
                      className={s.tableTitle}
                    >
                      {t("quantity")}
                    </TableCell>
                    <TableCell
                      sx={{ color: textColor }}
                      className={s.tableTitle}
                    >
                      {t("movement")}
                    </TableCell>
                  </TableHead>
                  <TableBody>
                    {items?.map((item, i) => (
                      <React.Fragment key={item.id}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.raffle?.serie || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.deliveryNoteOutputId ||
                              item?.deliveryNoteInputId ||
                              "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {<Currency value={item?.raffle?.price} /> || "-"}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >{`${item?.raffle?.percentage || "-"} %`}</TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.nroCouponFrom || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.nroCouponTo || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {`${item?.nroCouponTo - item?.nroCouponFrom + 1}` ||
                              "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.deliveryNoteInputId
                              ? t("income")
                              : t("discharge")}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sx={{
                minHeight: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "1.8rem",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 300,
              }}
            >
              {t("doASearch")}
            </Grid>
          )}
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: "50px",
        }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
      <Snackbar
        open={noResult}
        autoHideDuration={6000}
        onClose={() => setNoResult(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setNoResult(false)}
          severity="info"
          sx={{ width: "100%" }}
        >
          {t("noResults")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};
